import { render, staticRenderFns } from "./DocsDetailType.vue?vue&type=template&id=31446e29&"
import script from "./DocsDetailType.vue?vue&type=script&lang=js&"
export * from "./DocsDetailType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports